import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

const Header = () => (
  <Navbar bg="light">
        <Container>
          <Navbar.Brand>SD敢达RE机体资料站</Navbar.Brand>
        </Container>
    </Navbar>
);

export default Header;